// Paid Ads Service Page Content
import { FaBullseye, FaBolt, FaChartLine, FaDollarSign, FaFacebook, FaGoogle, FaSnapchat, FaTiktok, FaLinkedin, FaTwitter, FaEye, FaUsers, FaHeart, FaMousePointer, FaEnvelope, FaShoppingCart, FaVideo, FaMobileAlt, FaPencilAlt, FaCheckCircle, FaCog, FaRocket } from 'react-icons/fa';

export const paidAdsContent = {
  hero: {
    title: "إعلانات ممولة تحقق نتائج حقيقية",
    subtitle: "نُطلق لك حملات إعلانية فعّالة ومدروسة تستهدف جمهورك المثالي وتحقق أفضل عائد على استثمارك",
    buttonText: "ابدأ حملتك الآن",
    imageUrl: "https://via.placeholder.com/800x500/1A4D5C/2DD4BF?text=Paid+Ads"
  },

  whyNeed: {
    title: "لماذا تحتاج إعلانات ممولة؟",
    subtitle: "الإعلانات الممولة هي أسرع طريقة للوصول لعملائك المثاليين",
    reasons: [
      {
        id: 1,
        icon: FaBullseye,
        title: "استهداف دقيق",
        description: "تصل للعملاء المهتمين فعلاً بمنتجك"
      },
      {
        id: 2,
        icon: FaBolt,
        title: "نتائج سريعة",
        description: "تبدأ تحصل على نتائج من اليوم الأول"
      },
      {
        id: 3,
        icon: FaChartLine,
        title: "قابلة للقياس",
        description: "تعرف بالضبط كم صرفت وكم ربحت"
      },
      {
        id: 4,
        icon: FaDollarSign,
        title: "عائد على الاستثمار",
        description: "كل ريال تصرفه يجيب لك عملاء جدد"
      }
    ]
  },

  platforms: {
    title: "نُدير إعلاناتك على أهم المنصات",
    subtitle: "نختار المنصة المناسبة لجمهورك وأهدافك",
    items: [
      {
        id: 1,
        icon: FaFacebook,
        title: "Facebook & Instagram Ads",
        description: "الأوسع انتشاراً في المنطقة"
      },
      {
        id: 2,
        icon: FaGoogle,
        title: "Google Ads",
        description: "تظهر لمن يبحث عن خدماتك"
      },
      {
        id: 3,
        icon: FaSnapchat,
        title: "Snapchat Ads",
        description: "مثالي للوصول للشباب السعودي"
      },
      {
        id: 4,
        icon: FaTiktok,
        title: "TikTok Ads",
        description: "الأسرع نمواً والأكثر تفاعلاً"
      },
      {
        id: 5,
        icon: FaLinkedin,
        title: "LinkedIn Ads",
        description: "للوصول لصناع القرار في الشركات"
      },
      {
        id: 6,
        icon: FaTwitter,
        title: "X (Twitter) Ads",
        description: "للوصول لجمهور متفاعل ومهتم"
      }
    ]
  },

  whatWeOffer: {
    title: "ما نقدمه في خدمة الإعلانات",
    features: [
      {
        id: 1,
        icon: FaRocket,
        title: "إعداد الحملات الإعلانية",
        description: "نجهز ونطلق حملاتك باحترافية"
      },
      {
        id: 2,
        icon: FaCog,
        title: "إعداد البيكسل (Pixel)",
        description: "نتتبع تحركات زوار موقعك لاستهداف أفضل"
      },
      {
        id: 3,
        icon: FaBullseye,
        title: "استهداف دقيق للجمهور",
        description: "نحدد الجمهور المثالي حسب العمر، الموقع، الاهتمامات"
      },
      {
        id: 4,
        icon: FaPencilAlt,
        title: "كتابة النصوص الإعلانية",
        description: "نصوص جذابة تحفّز على الشراء"
      },
      {
        id: 5,
        icon: FaVideo,
        title: "تصميم المواد الإعلانية",
        description: "صور وفيديوهات احترافية للإعلانات"
      },
      {
        id: 6,
        icon: FaCheckCircle,
        title: "اختبار A/B Testing",
        description: "نجرب أكثر من نسخة ونختار الأفضل"
      },
      {
        id: 7,
        icon: FaChartLine,
        title: "تحسين يومي",
        description: "نراقب الأداء ونحسّنه باستمرار"
      },
      {
        id: 8,
        icon: FaChartLine,
        title: "تقارير دورية",
        description: "تقارير واضحة توضح النتائج والإنفاق"
      }
    ]
  },

  portfolio: {
    title: "نماذج من حملاتنا الإعلانية الناجحة",
    subtitle: "حملات حققت نتائج استثنائية لعملائنا",
    projects: [
      {
        id: 1,
        title: "حملة فيسبوك - متجر إلكتروني",
        platform: "Facebook & Instagram Ads",
        description: "حملة إعلانية لمتجر إلكتروني متخصص في الأزياء النسائية",
        image: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=800&q=80",
        metrics: ["ROI 420%", "1,250 عملية بيع", "تكلفة عميل 22 ريال"]
      },
      {
        id: 2,
        title: "حملة جوجل - خدمات تقنية",
        platform: "Google Ads",
        description: "حملة إعلانية عبر محرك البحث جوجل لشركة خدمات تقنية",
        image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
        metrics: ["180 استفسار", "معدل تحويل 8.5%", "انخفاض التكلفة 45%"]
      },
      {
        id: 3,
        title: "حملة سناب شات - مطعم",
        platform: "Snapchat Ads",
        description: "حملة إعلانية لمطعم برجر محلي استهدفت الشباب في المنطقة",
        image: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&q=80",
        metrics: ["50K مشاهدة", "+300% زوار", "2,500 طلب جديد"]
      },
      {
        id: 4,
        title: "حملة تيك توك - مركز تجميل",
        platform: "TikTok Ads",
        description: "حملة فيديو فيرالية لمركز تجميل وعناية بالبشرة",
        image: "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=800&q=80",
        metrics: ["200K مشاهدة", "850 حجز موعد", "معدل تفاعل 12%"]
      },
      {
        id: 5,
        title: "حملة لينكد إن - شركة B2B",
        platform: "LinkedIn Ads",
        description: "حملة استهداف احترافية لشركة برمجيات وخدمات تقنية للشركات",
        image: "https://images.unsplash.com/photo-1557838923-2985c318be48?w=800&q=80",
        metrics: ["95 عميل محتمل", "CPA 120 ريال", "نوعية عملاء ممتازة"]
      },
      {
        id: 6,
        title: "حملة متعددة القنوات - عقارات",
        platform: "Multi-Platform",
        description: "حملة شاملة على عدة منصات لمشروع عقاري سكني فاخر",
        image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80",
        metrics: ["350+ استفسار جاد", "40 بيع", "ROI 580%"]
      }
    ]
  },

  packagesSection: {
    title: "باقات إعلانية تناسب ميزانيتك",
    subtitle: "الأسعار أدناه لا تشمل ميزانية الإعلانات نفسها - فقط رسوم إدارة الحملات",
    note: "ملاحظة: الأسعار أدناه لا تشمل ميزانية الإعلانات نفسها - فقط رسوم إدارة الحملات"
  },

  packages: [
    {
      id: 'start',
      title: 'باقة البداية',
      subtitle: 'المشاريع الصغيرة والمبتدئين',
      isFeatured: false,
      features: [
        'إدارة حملة إعلانية واحدة',
        'منصة واحدة (Facebook/Instagram أو Google)',
        'استهداف أساسي للجمهور',
        'تصميم 2 إعلان',
        'كتابة نصوص إعلانية',
        'إعداد البيكسل',
        'متابعة يومية',
        'تقرير أسبوعي بسيط',
        'مدة الحملة: شهر واحد'
      ],
      whatsappMessage: `مرحباً

أنا مهتم بـــ باقة البداية للإعلانات الممولة

تفاصيل الباقة:
- حملة إعلانية واحدة
- منصة واحدة
- استهداف أساسي
- تصميم 2 إعلان
- إعداد البيكسل
- تقرير أسبوعي

أرغب في معرفة رسوم الإدارة والبدء.`
    },
    {
      id: 'grow',
      title: 'باقة النمو',
      subtitle: 'الشركات المتوسطة',
      badge: 'الأكثر طلباً',
      isFeatured: true,
      features: [
        'إدارة حملتين إعلانيتين',
        'منصتين (مثل Facebook + Google)',
        'استهداف متقدم ودقيق',
        'تصميم 5 إعلانات',
        'كتابة نصوص متنوعة',
        'إعداد وتحسين البيكسل',
        'اختبار A/B Testing',
        'تحسين يومي للأداء',
        'إعادة استهداف (Retargeting)',
        'تقرير أسبوعي مفصّل',
        'مدة الحملة: شهر واحد'
      ],
      whatsappMessage: `مرحباً

أنا مهتم بـــ باقة النمو للإعلانات الممولة

تفاصيل الباقة:
- حملتين إعلانيتين
- منصتين
- استهداف متقدم
- تصميم 5 إعلانات
- A/B Testing
- إعادة استهداف
- تقرير أسبوعي مفصّل

أرغب في معرفة رسوم الإدارة وحجز استشارة.`
    },
    {
      id: 'pro',
      title: 'باقة الاحتراف',
      subtitle: 'العلامات التجارية والشركات الكبيرة',
      isFeatured: false,
      features: [
        'إدارة 3 حملات أو أكثر',
        '3 منصات (Facebook, Google, Snapchat وغيرها)',
        'استهداف متقدم جداً (Lookalike, Custom Audiences)',
        'تصميم 10 إعلانات متنوعة',
        'كتابة نصوص مخصصة لكل جمهور',
        'فيديوهات إعلانية قصيرة',
        'اختبار A/B متقدم',
        'تحسين معدلات التحويل (CRO)',
        'إعادة استهداف متقدمة',
        'تقارير أسبوعية شاملة',
        'اجتماع أسبوعي لمناقشة النتائج',
        'استشارات تسويقية مستمرة',
        'مدة الحملة: شهر واحد (قابل للتجديد)'
      ],
      whatsappMessage: `مرحباً

أنا مهتم بـــ باقة الاحتراف للإعلانات الممولة

تفاصيل الباقة:
- 3 حملات أو أكثر
- 3 منصات
- استهداف متقدم جداً
- تصميم 10 إعلانات
- فيديوهات إعلانية
- تحسين التحويلات
- اجتماع أسبوعي

أرغب في معرفة رسوم الإدارة وتفاصيل أكثر.`
    }
  ],

  campaignTypes: {
    title: "حملات متنوعة لأهداف مختلفة",
    subtitle: "نختار نوع الحملة الأنسب لهدفك التسويقي",
    types: [
      {
        id: 1,
        icon: FaEye,
        title: "حملات الوعي (Awareness)",
        description: "تعرّف الناس بعلامتك التجارية"
      },
      {
        id: 2,
        icon: FaUsers,
        title: "حملات الوصول (Reach)",
        description: "توصل لأكبر عدد من الجمهور"
      },
      {
        id: 3,
        icon: FaHeart,
        title: "حملات التفاعل (Engagement)",
        description: "تزيد الإعجابات والتعليقات"
      },
      {
        id: 4,
        icon: FaMousePointer,
        title: "حملات الزيارات (Traffic)",
        description: "تجيب زوار لموقعك"
      },
      {
        id: 5,
        icon: FaEnvelope,
        title: "حملات جمع البيانات (Leads)",
        description: "تجمع معلومات العملاء المحتملين"
      },
      {
        id: 6,
        icon: FaShoppingCart,
        title: "حملات المبيعات (Conversions)",
        description: "تحوّل الزوار لعملاء فعليين"
      },
      {
        id: 7,
        icon: FaVideo,
        title: "حملات الفيديو (Video Views)",
        description: "تزيد مشاهدات فيديوهاتك"
      },
      {
        id: 8,
        icon: FaMobileAlt,
        title: "حملات التطبيقات (App Install)",
        description: "تزيد تحميلات تطبيقك"
      }
    ]
  },

  performanceMetrics: {
    title: "ماذا نحقق لعملائنا؟",
    subtitle: "نتائج حقيقية وقابلة للقياس",
    metrics: [
      {
        id: 1,
        icon: FaChartLine,
        title: "ROI متوسط 380%",
        description: "متوسط العائد على الاستثمار الذي يحققه عملاؤنا من حملاتنا الإعلانية"
      },
      {
        id: 2,
        icon: FaDollarSign,
        title: "خفض التكلفة 45%",
        description: "نخفض تكلفة الاكتساب بمعدل 45% مقارنة بالحملات غير المحسّنة"
      },
      {
        id: 3,
        icon: FaMousePointer,
        title: "معدل تحويل 8.5%",
        description: "متوسط معدل التحويل الذي نحققه عبر الحملات المُحسّنة"
      },
      {
        id: 4,
        icon: FaBullseye,
        title: "استهداف دقيق 95%",
        description: "نصل للجمهور المستهدف بدقة عالية جداً"
      }
    ]
  },

  ourDifference: {
    title: "ما الذي يميزنا في إدارة الإعلانات؟",
    subtitle: "نجمع بين الخبرة والتقنية والإبداع",
    differences: [
      {
        id: 1,
        icon: FaCog,
        title: "تحسين مستمر",
        description: "نراقب الحملات يومياً ونحسّن الأداء باستمرار لضمان أفضل نتائج"
      },
      {
        id: 2,
        icon: FaPencilAlt,
        title: "إعلانات مبتكرة",
        description: "نصمم إعلانات جذابة ونصوص مقنعة تحفز العملاء على اتخاذ القرار"
      },
      {
        id: 3,
        icon: FaChartLine,
        title: "تقارير شفافة",
        description: "تقارير تفصيلية توضح كل ريال تم صرفه وماذا حقق"
      },
      {
        id: 4,
        icon: FaBullseye,
        title: "A/B Testing دائم",
        description: "نختبر كل شيء لنصل للنسخة الأفضل أداءً"
      }
    ]
  },

  guarantees: {
    title: "ضماناتنا لك في الإعلانات الممولة",
    items: [
      {
        id: 1,
        icon: FaCheckCircle,
        title: "شفافية كاملة",
        description: "تقارير يومية وأسبوعية توضح الأداء والإنفاق بالتفصيل"
      },
      {
        id: 2,
        icon: FaBullseye,
        title: "استهداف دقيق",
        description: "نضمن وصول إعلاناتك للجمهور المناسب بناءً على تحليل دقيق"
      },
      {
        id: 3,
        icon: FaCog,
        title: "تحسين مستمر",
        description: "مراقبة يومية وتحسين للحملات لتحقيق أفضل عائد على الاستثمار"
      },
      {
        id: 4,
        icon: FaRocket,
        title: "نتائج ملموسة",
        description: "نركز على تحقيق نتائج حقيقية قابلة للقياس لا مجرد أرقام"
      }
    ]
  },

  process: {
    title: "كيف نُدير حملاتك الإعلانية؟",
    steps: [
      {
        id: 1,
        number: "1",
        icon: FaBullseye,
        title: "فهم الأهداف",
        description: "نحدد هدفك الأساسي من الإعلانات"
      },
      {
        id: 2,
        number: "2",
        icon: FaUsers,
        title: "تحليل الجمهور",
        description: "ندرس جمهورك ونحدد الاستهداف الأمثل"
      },
      {
        id: 3,
        number: "3",
        icon: FaPencilAlt,
        title: "إنشاء الإعلانات",
        description: "نصمم ونكتب إعلانات جذابة"
      },
      {
        id: 4,
        number: "4",
        icon: FaRocket,
        title: "إطلاق الحملات",
        description: "نطلق الحملة مع ضبط دقيق للميزانية"
      },
      {
        id: 5,
        number: "5",
        icon: FaChartLine,
        title: "المتابعة والتحسين",
        description: "نراقب الأداء ونحسّن يومياً"
      },
      {
        id: 6,
        number: "6",
        icon: FaCheckCircle,
        title: "التقارير والنتائج",
        description: "نرسل تقارير دورية توضح النتائج"
      }
    ]
  },

  faq: {
    title: "أسئلة شائعة عن الإعلانات الممولة",
    items: [
      {
        id: 1,
        question: "كم أحتاج ميزانية إعلانية شهرياً؟",
        answer: "يعتمد على أهدافك، لكن ننصح بميزانية لا تقل عن 1,500 ريال شهرياً للحملات الفعّالة"
      },
      {
        id: 2,
        question: "كم تستغرق الحملة لتبدأ تعطي نتائج؟",
        answer: "بعض الحملات تعطي نتائج من اليوم الأول، لكن عموماً تحتاج 3-7 أيام للتحسين والوصول للأداء الأمثل"
      },
      {
        id: 3,
        question: "هل تضمنون نتائج محددة؟",
        answer: "نضمن بذل أقصى جهد واحترافية، لكن النتائج تعتمد على عوامل كثيرة (المنتج، السوق، الميزانية)"
      },
      {
        id: 4,
        question: "على أي منصة أبدأ؟",
        answer: "نساعدك نختار المنصة الأنسب بناءً على جمهورك وأهدافك"
      },
      {
        id: 5,
        question: "هل تشمل الباقة تصميم الإعلانات؟",
        answer: "نعم، جميع الباقات تشمل تصميم وكتابة الإعلانات"
      }
    ]
  },

  finalCTA: {
    title: "جاهز لحملة إعلانية ناجحة؟",
    subtitle: "تواصل معنا الآن وابدأ حملتك الأولى",
    buttonText: "ابدأ حملتك الآن"
  }
};
